import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getValidToken } from "../utils/tokenManager";
import Lottie from "lottie-react";
import loadingAnim from "../assets/common/json-Animacin-carga-.json";

const ContactContext = createContext();

export const useContactContext = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error('useContactContext must be used within a ContactProvider');
  }
  return context;
};

export const ContactProvider = ({ children }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContacts = useCallback(async (signal) => {
    try {
      const accessToken = await getValidToken();
      setLoading(true);
      setError(null);

      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_APIBASEURL}/api/calls/assigned`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        ...(signal && { signal }),
      };

      const response = await axios.request(config);
      setContacts(response.data.contacts.contacts);
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Error fetching contacts:", error);
        setError(error);
        setContacts([]);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  // Categorize contacts
  const meetingRecovery = contacts.filter(
    (c) => c.callType === "meeting_recovery"
  );
  const meetingContacts = contacts.filter(
    (c) => c.callType === "meeting_confirmation"
  );
  const followUpContacts = contacts.filter((c) => c.callType === "follow_up");
  const coldCallContacts = contacts.filter((c) => c.callType === "cold_call");

  // Refresh contacts manually
  const refreshContacts = useCallback(async () => {
    return fetchContacts();
  }, [fetchContacts]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchContacts(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [fetchContacts]);

  const value = {
    contacts,
    meetingRecovery,
    meetingContacts,
    followUpContacts,
    coldCallContacts,
    loading,
    error,
    refreshContacts,
  };

  return (
    <ContactContext.Provider value={value}>
      {/* Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000] bg-opacity-30 px-4">
          <div className="bg-white rounded-lg text-secondary text-xl shadow-xl p-6 relative flex flex-col items-center">
            <Lottie
              animationData={loadingAnim}
              loop
              autoplay
              style={{ height: "5rem", width: "5rem" }}
            />
          </div>
        </div>
      )}

     

      {/* App Content */}
      {children}
    </ContactContext.Provider>
  );
};
